import React from "react";

const sizes = {
  sm: "h-5 w-5 border-2",
  md: "h-8 w-8 border-2",
  lg: "h-12 w-12 border-3",
};

const Loader = ({ fullscreen = false, text = "Loading...", size = "md", overlay = false }) => {
  const spinnerSize = sizes[size] || sizes.md;
  const content = (
    <div className="flex flex-col items-center justify-center gap-3 p-6">
      <div className={`animate-spin rounded-full border-gray-300 border-t-blue-500 ${spinnerSize}`}></div>
      {text ? <p className="text-sm text-gray-600">{text}</p> : null}
    </div>
  );

  if (fullscreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        {overlay && <div className="absolute inset-0 bg-black/10" />}
        <div className="relative">{content}</div>
      </div>
    );
  }

  return content;
};

export default Loader;
